import { TtsPlayer } from "./ttsPlayer";

// アプリ全体で 1 つの TtsPlayer を共有する。
//
// iOS (WebKit) の autoplay 許可は <audio> **要素単位**で与えられ、その要素を
// ユーザー操作のコールスタックの中で play() したときにしか得られない
// (不変条件の詳細は ttsPlayer.ts のクラス冒頭)。事前チェックと本編が別インスタンスを
// 持つと、事前チェックのタップで得た許可が本編の読み上げに引き継がれず、
// **アンケート本体が iPhone で無音になる**。wizard で唯一確実に得られるユーザー操作は
// 「はじめる」のタップなので、そこで 1 つの要素をアンロックし、最後まで使い回す。
//
// 出力デバイス (sinkId) の適用箇所が 1 つで済むという既存の利点もそのまま残る
// (usePreflightVoice が wizard 内で 1 インスタンスに集約していた理由と同じ)。
//
// **生成は遅延させる** — import 時に作ると、モジュール読み込みの時点で <audio> 要素が
// 生まれ、テストの vi.mock factory より先に走って TDZ を踏む。実行時も「まだ一度も
// 読み上げない画面」で要素を作る理由が無い。
//
// テストからは new TtsPlayer() を使うこと。
let instance: TtsPlayer | null = null;

export function getTtsPlayer(): TtsPlayer {
  return (instance ??= new TtsPlayer());
}
